export const chartGaugeTemplate = {
    chartOptions: {
        plotOptions: {
            radialBar: {
                size: 158,
                offsetY: -30,
                startAngle: -150,
                endAngle: 150,
                hollow: {
                    size: '65%'
                },
                track: {
                    background: 'rgba(0,0,0,0)',
                    strokeWidth: '100%'

                },
                dataLabels: {
                    value: {
                        offsetY: 30,
                        color: '#99a2ac',
                        fontSize: '2rem',
                        formatter: function (val) {
                            return val
                        }
                    }
                }
            }
        },
        colors: ['#7ede1e'],
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'dark',
                type: 'horizontal',
                shadeIntensity: 0.5,
                gradientToColors: ['#ddc42a'],
                inverseColors: true,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 720]
            }
        },
        stroke: {
            dashArray: 0
        },
        chart: {
            sparkline: {}
        },
        labels: ['Búro de credito']
    },
    supportTracker: {
        series: [83]
    }
}
